import { useState, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import Toolbar from "../controls/Toolbar";
import ListItem from "../controls/ListItem";

const LogList = ({ onClick = () => { } }) => {
    const history = useHistory();
    const location = useLocation();

    const [data] = useState([
        {
            name: "Error",
            type: "error"
        },
        {
            name: "Info",
            type: "info"
        }
    ]);
    const [translate] = useTranslation();

    const handleClick = useCallback((type) => {
        history.push("/domain-logs/" + type);
        onClick();
    }, [history, onClick]);

    const isActive = useCallback((type) => {
        return location.pathname.includes(type);
    }, [location.pathname]);

    const renderToolbar = useMemo(() => {
        return <Toolbar
            heading={translate("OTM_LOGS")} />
    }, [translate])

    return (
        <div className="card">
            <div className="card-header border-bottom">
                {renderToolbar}
            </div>
            <div className="card-body">
                <ul className="list-group">
                    {data.map((element, index) => (
                        <ListItem
                            value={element["name"]}
                            logType={element["type"]}
                            dataElement={element["type"]}
                            key={index}
                            onClick={handleClick}
                            url={"/domain-logs/" + element["type"] + "/"}
                            type="log"
                            active={isActive(element["type"])}
                        />
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default LogList;